module.exports = __webpack_public_path__ + "static/media/Sun.b086e905.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Players/Sun.jpg
// module id = 189
// module chunks = 0